<template>
    <div v-if="team.sharing_enabled && (form.settings.can_be_shared || form.settings.can_be_shared_link)">
      <v-text-field v-model="form.facebook_pixel"
                    v-if="team.facebook_enabled"
                    label="Facebook Pixel"
                    placeholder=" "
                    autocomplete="off"
                    hint="If you want Facebook to track activity, enter the pixel ID.">
      </v-text-field>

      <v-text-field v-model="form.google_analytics_id"
                    v-if="team.google_analytics_enabled"
                    label="Google Analytics Property ID"
                    placeholder="UA-XXXXXX-Y"
                    autocomplete="off"
                    hint="If you want Google to track activity, enter the GA property ID.">
      </v-text-field>

      <v-text-field v-model="form.hubspot_pixel"
                    v-if="team.hubspot_enabled"
                    label="Hubspot Pixel ID"
                    placeholder=" "
                    autocomplete="off"
                    hint="If you want Hubspot to track activity, enter the pixel ID.">
      </v-text-field>

      <v-text-field v-model="form.linkedin_pixel"
                    v-if="team.linkedin_enabled"
                    label="LinkedIn Partner ID"
                    placeholder=" "
                    autocomplete="off"
                    hint="If you want LinkedIn to track activity, enter the partner ID.">
      </v-text-field>
    </div>
</template>
<script>
import {mapGetters} from 'vuex';

export default {
  props: {
    form: {
      type: Object,
      required: true,
    },
    presentation: {
      type: Object,
      required: false,
    },
  },
  computed: {
    ...mapGetters([
      'team',
      'user',
    ])
  }
}
</script>
